@if (isLoadingNavigation()) {
  <div class="app-navbar-skeleton-overlay">
    <cm-skeleton-loader preset="navbar" />
  </div>
}
@if (closingSession()) {
  <div class="app-closing-session-overlay">
    <cm-spinner [loading]="true" size="large" loadingText="Closing session" />
    <p class="app-closing-session-overlay__label">Closing session</p>
  </div>
}
<router-outlet />
